var render = function render(){var _vm=this,_c=_vm._self._c;return _c('http-post-button',_vm._g(_vm._b({attrs:{"href":"/api/fxrates/tenant","version":"v2"},on:{"http4xx":_vm.onError}},'http-post-button',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }